import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function SkipperCanteenOpen() {
  const dateTexts = ['193x年'];
  const title = 'スキッパーキャンティーン オープン';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/skipper-canteen-walt-disney-world-restaurant-001.jpg'
  const description = (
    <>
      {'ジャングルクルーズは大反響を呼び、ジャングルクルーズの開始から数年後、ジャングルナビゲーションカンパニーのオフィスの一部を利用したダイニング「'}
      <a href='/skipper-canteen'>
        {'スキッパーキャンティーン'}
      </a>
      {'」の提供が開始される。'}
    </>
  );
  const quoteDomain = 'disneytouristblog.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default SkipperCanteenOpen;
